import { Action, createStore, applyMiddleware, compose, StoreEnhancer } from 'redux';
import { IAppState } from './appstate';
import { reducer } from './reducer';


declare var window: any;

const devToolsExtention: StoreEnhancer = (window.devToolsExtention) ? window.devToolsExtention() : (f) => f;


export const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());